"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_1 = require("./app");
const responseError = require("./common/responseError");
const identifiers_1 = require("./identifiers");
const getCourseEnrollments_1 = require("./getCourseEnrollments");
function getCourses({ ownerId, enrollmentCode, depricated, courseId, studentId, domainId }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            let courseRef = app_1.app.firestore.collection('courses');
            if (courseId) {
                return [yield getCourseDoc(courseRef, courseId)];
            }
            else if (studentId) {
                const courseEnrollments = yield getCourseEnrollments_1.default({
                    userId: studentId
                });
                console.log('courseEnrollments', courseEnrollments);
                const courseDocs = [];
                for (const courseEnrollment of courseEnrollments) {
                    courseDocs.push(yield getCourseDoc(courseRef, courseEnrollment.courseId));
                }
                return courseDocs;
            }
            else {
                if (domainId) {
                    courseRef = courseRef.where('domainId', '==', domainId);
                }
                if (ownerId) {
                    courseRef = courseRef.where('ownerId', '==', ownerId);
                }
                if (enrollmentCode) {
                    courseRef = courseRef.where('enrollmentCode', '==', enrollmentCode);
                }
                if (!depricated) {
                    courseRef = courseRef.where('courseState', '==', identifiers_1.Types.CourseStates.ACTIVE);
                }
                const querySnapshot = yield courseRef.get();
                const courses = [];
                querySnapshot.forEach(doc => {
                    courses.push(Object.assign({}, doc.data(), { id: doc.id }));
                });
                return courses;
            }
        }
        catch (e) {
            throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, e.message);
        }
    });
}
exports.default = getCourses;
function getCourseDoc(courseRef, courseId) {
    return __awaiter(this, void 0, void 0, function* () {
        const doc = yield courseRef.doc(courseId).get();
        const course = Object.assign({}, doc.data(), { id: doc.id });
        return course;
    });
}
//# sourceMappingURL=getCourses.js.map